
import Config from "../utils/Config";
import Middleware from "./Middleware";


class LegacyService {
  config = {
    headers: {
      Authorization: "",
      CompanyId: "",
    },
  };

  setAccessToken(accessToken, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.CompanyId = companyId;
  }
    
  async getArchieveMeetingList(companyId, accessToken, meetingType, startDate, endDate, page = 1, size = 20) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      `/apiVWeb/legacy/meeting?type=${meetingType}&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`,
      {
        ...this.config,
      }
    );
    return res;
  }

  async getCommitteeTypes(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      Config.BACKEND_URL + `/api/legacy/committee-types`,
      {
        ...this.config,
      }
    );
    return res;
  }

  async getCommitteesByCommitteeType(companyId, accessToken, committeeTypeId) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      Config.BACKEND_URL + `/api/legacy/committee-types/${committeeTypeId}/committees`,
      {
        ...this.config,
      }
    );
    return res;
  }

  async getMeetingsByCommitteeId(companyId, accessToken, committeeId, meetingType, startDate, endDate, page = 1, size = 20) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      Config.BACKEND_URL + `/api/legacy/committees/${committeeId}/meetings?type=${meetingType}&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`,
      {
        ...this.config,
      }
    );
    return res;
  }

  async getLegacyMeetingDetails(companyId, accessToken, meetingId) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      Config.BACKEND_URL + `/apiVWeb/legacy/meeting/${meetingId}`,
      {
        ...this.config,
      }
    );
    return res;
  }

  async downloadLegacyPaperDocument(companyId, accessToken, paperId, documentId) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      Config.BACKEND_URL + `/api/legacy/meeting/papers/${paperId}/documents/${documentId}/download`,
      {
        ...this.config,
        responseType: "blob",
      }
    );
    return res;
  }

  async downloadMeetingMinute(companyId, accessToken, meetingId){
    this.setAccessToken(accessToken,companyId);

    const response = await Middleware.api.get(Config.BACKEND_URL+`/api/legacy/meeting/${meetingId}/minute/download`,{
      ...this.config,
      responseType:"blob"
    });
    return response;
  }
}

export default new LegacyService();